{
  "chapel": {
    "u0": -37,
    "chordU": 19,
    "vc": 5,
    "half": 5,
    "eaveY": 11.8,
    "ridgeY": 18.2,
    "apse": "flat"
  },
  "belfry": {
    "u": -30,
    "v": 5,
    "radius": 0.65,
    "foot": 17.3,
    "eaves": 20.1,
    "tip": 24
  },
  "ranges": [
    {
      "id": "west-upper-range",
      "u": -21.5,
      "v": -6,
      "angleDeg": -43,
      "length": 18,
      "width": 6,
      "eaves": 7.5,
      "ridge": 11.5,
      "floors": 2,
      "bays": 5,
      "roof": "slate",
      "passage": 3,
      "roofGables": {
        "centres": [-5, 0, 5],
        "halfWidth": 0.7,
        "v0": 0.9,
        "v1": 3,
        "eaves": 10.6,
        "ridge": 11.4,
        "sill": 8.2,
        "top": 9.3
      },
      "passageU": 6.5
    },
    {
      "id": "west-lower-range",
      "u": -4,
      "v": -18.5,
      "angleDeg": -40,
      "length": 25,
      "width": 6,
      "eaves": 7.5,
      "ridge": 11.5,
      "floors": 2,
      "bays": 6,
      "roof": "slate",
      "passage": 0,
      "roofGables": {
        "centres": [-6, 6],
        "halfWidth": 0.7,
        "v0": 0.9,
        "v1": 3,
        "eaves": 10.6,
        "ridge": 11.4,
        "sill": 8.2,
        "top": 9.3
      }
    },
    {
      "id": "orchard-cross-range",
      "u": 5,
      "v": -14,
      "angleDeg": -90,
      "length": 26,
      "width": 7,
      "eaves": 8.8,
      "ridge": 13,
      "floors": 2,
      "bays": 8,
      "roof": "slate",
      "passage": 3,
      "roofGables": {
        "centres": [-8, 0, 8],
        "halfWidth": 1,
        "v0": 1.4,
        "v1": 3.5,
        "eaves": 11.6,
        "ridge": 12.9,
        "sill": 9.3,
        "top": 10.3
      },
      "windowRows": [
        {
          "sill": 1.1,
          "top": 3.3
        },
        {
          "sill": 5.1,
          "top": 7.5,
          "round": true
        }
      ]
    },
    {
      "id": "chapel-side-house",
      "u": -18,
      "v": -2.5,
      "angleDeg": 0,
      "length": 9,
      "width": 5,
      "eaves": 6.8,
      "ridge": 10.3,
      "floors": 2,
      "bays": 3,
      "roof": "slate",
      "passage": 0
    }
  ],
  "courts": [
    [1.2, -0.6],
    [1.2, -18.621],
    [-11.678, -7.815],
    [-13.043, -9.442],
    [-17.539, -5.25],
    [-13.25, -5.25],
    [-13.25, -0.6]
  ],
  "orchard": {
    "u0": 9,
    "u1": 19,
    "v0": -24,
    "v1": -1.2
  },
  "herbs": {
    "u0": -11,
    "u1": -2,
    "v0": -7,
    "v1": -2.5
  },
  "trees": [
    [11, -5],
    [16, -6],
    [11, -12],
    [16, -13],
    [11, -19],
    [16, -20]
  ],
  "walls": [
    {
      "from": [9, -24.1],
      "to": [19.2, -24.1],
      "width": 0.3,
      "height": 1.4
    },
    {
      "from": [19.2, -24.1],
      "to": [19.2, -1],
      "width": 0.3,
      "height": 1.4
    }
  ],
  "note": "The 1538 painting and 1544 woodcut guide the long flat-ended chapel, roof belfry, bent western range behind rented Turfmarkt houses, chapel-side house, tall cross-wing with round-headed upper windows and three roof gablets, open court and separate orchard. The 1760 print is an interpretation derived from the 1544 map, not an independent survey. All dimensions, axis fits, elevations, bays, hidden facades, passages, herb-plot shape and fruit-tree positions/count are estimates. Existing water boundaries constrain this provisional core; the precise southern limits and the unbuilt southern range remain unresolved. The separate Scafferij/paterserf island, rental frontage and Nonnen waters stay outside the reservation. Later hospital wings, ornamental gardens, connecting gallery, Grimnessesluis and internal public streets are not backdated."
}
